import { shape } from 'prop-types';
import React from 'react';

const InvoiceEN = ({ colors }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 206 224">
    <rect
      width="205.567"
      height="223.654"
      x="0.173"
      y="0.173"
      fill="#fff"
      rx="5.392"
    ></rect>
    <path
      fill="#000"
      d="M17.978 35V22.238h-2.52V35h2.52zm5.126-5.094c0-1.026.612-1.836 1.656-1.836 1.152 0 1.638.774 1.638 1.764V35h2.394v-5.58c0-1.944-1.008-3.51-3.204-3.51-.954 0-2.016.414-2.556 1.332v-1.098H20.71V35h2.394v-5.094zm16.311-3.762h-2.52l-2.106 5.94-2.196-5.94h-2.628L33.583 35h2.394l3.438-8.856zm5.171 6.948c-1.17 0-2.25-.864-2.25-2.52 0-1.674 1.08-2.52 2.25-2.52s2.25.846 2.25 2.52-1.08 2.52-2.25 2.52zm0-7.218c-2.646 0-4.644 1.962-4.644 4.698 0 2.718 1.998 4.698 4.644 4.698s4.644-1.98 4.644-4.698c0-2.736-1.998-4.698-4.644-4.698zM53.514 35v-8.856H51.12V35h2.394zm-2.682-11.754c0 .792.666 1.458 1.476 1.458.828 0 1.476-.666 1.476-1.458 0-.828-.648-1.494-1.476-1.494-.81 0-1.476.666-1.476 1.494zm9.223 4.842c1.188 0 1.746.756 1.962 1.494l2.142-.72c-.378-1.494-1.746-2.988-4.158-2.988-2.574 0-4.59 1.962-4.59 4.698 0 2.718 2.052 4.698 4.662 4.698 2.358 0 3.744-1.512 4.14-2.988l-2.106-.702c-.198.684-.81 1.494-2.034 1.494-1.224 0-2.268-.9-2.268-2.502 0-1.602 1.026-2.484 2.25-2.484zm7.576 1.476c.054-.81.738-1.746 1.98-1.746 1.368 0 1.944.864 1.98 1.746h-3.96zm4.194 2.304c-.288.792-.9 1.35-2.016 1.35-1.188 0-2.178-.846-2.232-2.016h6.336c0-.036.036-.396.036-.738 0-2.844-1.638-4.59-4.374-4.59-2.268 0-4.356 1.836-4.356 4.662 0 2.988 2.142 4.734 4.572 4.734 2.178 0 3.582-1.278 4.032-2.808l-1.998-.594zM191.601 32.318c-.576.486-1.404.774-2.376.774-1.242 0-2.358-.522-2.988-1.62h2.592l.774-1.692h-3.888c-.036-.324-.036-.45-.036-.558 0-.198 0-.342.036-.594h4.356l.792-1.692h-4.68c.648-1.188 1.818-1.728 3.042-1.728.864 0 1.62.18 2.178.558l.918-1.89c-.81-.522-1.782-.828-3.096-.828-2.484 0-4.788 1.44-5.652 3.888h-1.674v1.692h1.314c-.018.288-.018.432-.018.576 0 .162 0 .252.018.576h-1.314v1.692h1.674c.864 2.43 3.114 3.816 5.652 3.816 1.44 0 2.664-.522 3.492-1.188l-1.116-1.782z"
    ></path>
    <path
      stroke="#A29C95"
      strokeWidth="0.173"
      d="M192.239 48.087L13.855 48.087"
    ></path>
    <path
      stroke="#A29C95"
      strokeWidth="0.173"
      d="M192.239 110L13.855 110"
    ></path>
    <rect
      width="7.045"
      height="7.045"
      x="13.913"
      y="86.868"
      fill={colors?.brand?.primary}
      rx="1.503"
    ></rect>
    <path
      stroke="#fff"
      strokeWidth="0.501"
      d="M19.58 88.722l-2.816 3.232-1.368-1.482"
    ></path>
    <rect
      width="69.448"
      height="4.341"
      x="28.507"
      y="88.251"
      fill="#8990A3"
      fillOpacity="0.25"
      rx="2.17"
    ></rect>
    <rect
      width="177.961"
      height="4.341"
      x="14.039"
      y="60"
      fill="#8990A3"
      fillOpacity="0.25"
      rx="2.17"
    ></rect>
    <rect
      width="177.961"
      height="4.341"
      x="14.039"
      y="117"
      fill="#8990A3"
      fillOpacity="0.25"
      rx="2.17"
    ></rect>
    <rect
      width="177.961"
      height="4.341"
      x="14.039"
      y="190"
      fill="#8990A3"
      fillOpacity="0.25"
      rx="2.17"
    ></rect>
    <rect
      width="177.961"
      height="4.341"
      x="14.039"
      y="73.783"
      fill="#8990A3"
      fillOpacity="0.25"
      rx="2.17"
    ></rect>
    <rect
      width="177.961"
      height="4.341"
      x="14.039"
      y="130.783"
      fill="#8990A3"
      fillOpacity="0.25"
      rx="2.17"
    ></rect>
    <rect
      width="82"
      height="4"
      x="62"
      y="204"
      fill={colors?.brand?.lighter}
      fillOpacity="0.5"
      rx="2"
    ></rect>
    <rect
      width="176.581"
      height="25.95"
      x="14.486"
      y="146.348"
      fill="#fff"
      stroke={colors?.brand?.primary}
      strokeDasharray="2.09 2.09"
      strokeWidth="0.696"
      rx="3.13"
    ></rect>
    <rect
      width="205.567"
      height="223.654"
      x="0.173"
      y="0.173"
      stroke="#E1E1E1"
      strokeWidth="0.346"
      rx="5.392"
    ></rect>
    <path
      stroke={colors?.brand?.primary}
      strokeWidth="0.696"
      d="M31.013 157.188l1.233-1.232a.348.348 0 000-.493h0m-1.233 1.725l1.479-1.971-.246.246m-1.233 1.725l-2.464-2.464m2.464 2.464l-2.464-2.464m3.697.739l-1.972-1.972m1.972 1.972l-1.972-1.972m0 0s0 0 0 0a.35.35 0 00-.493 0s0 0 0 0l-1.232 1.233m1.725-1.233l-1.725 1.233m-8.027 8.027l6.55-6.55 2.464 2.465-6.55 6.549h-2.464v-2.464z"
    ></path>
  </svg>
);

InvoiceEN.defaultProps = {
  colors: {},
};

InvoiceEN.propTypes = {
  colors: shape(),
};

export default InvoiceEN;
